import { useDispatch } from 'react-redux';
import { showNotification } from '../../store/actions/uiActions';

/**
 * 自定义Hook，用于在组件中使用通知功能
 * 提供与Trans页面一致的消息提醒样式
 */
export const useNotification = () => {
  const dispatch = useDispatch();

  return {
    success: (message) => dispatch(showNotification(message, 'success')),
    error: (message) => dispatch(showNotification(message, 'error')),
    warning: (message) => dispatch(showNotification(message, 'warning')),
    info: (message) => dispatch(showNotification(message, 'info'))
  };
};

export default useNotification; 